import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.css']
})
export class LanguageComponent implements OnInit {
    languageId;

    public edit?: Edit;

    public selectListDateFormats: DateFormatItem[] = [];

    public saving = false;

    public languageNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'languagelangs', gotoParms: () => this.edit!.language_id ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.languageId = this.stateService.getStateParams()['language_id'];
    }

    private async loadEdit() {
        if (!!this.languageId) {
            this.edit = (await this.datatask.Post(3347, { language_id: this.languageId }))[0];
        }
    }

    private async loadDateFormats(): Promise<void> {
        this.selectListDateFormats = await this.datatask.Post(3348);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3349, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadDateFormats();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    language_id: string;
    language_name: string;
    sortorder: number;
    date_format: string;
    is_new: string;
}

interface DateFormatItem {
    date_format: string;
    date_format_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('language', {
//        templateUrl: 'views/components/views/language/language.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'languageEditService', function ($stateParams, stateService, translateService, modalService, languageEditService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let languageId = $stateParams.language_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                languageNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('languagelangs', { language_id: vm.model.edit.language_id }) }
//                ],
//                edit: {},
//                selectListDateFormats: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await languageEditService.getEdit({ language_id: languageId }))[0];
//            }

//            async function loadDateFormats() {
//                vm.model.selectListDateFormats = await languageEditService.listDateFormats();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                languageEditService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadDateFormats();
//            }

//            // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
